export enum PhoneNumbersEnum {
    Eurocross = '+31 (0)71 364 17 62',
    EurocrossURL = '+31713641762',
}
